<template>
  <div class="singleDisbursementModal">
    <el-dialog :visible.sync="dialogVisible" class="diglog-card" :title="!isEdit ? $t('data.add_receiver') : $t('data.edit_receiver')" :close-on-click-modal="false" width="508px">
      <div class="form-container">
        <el-form ref="form" :rules="rule" :model="form" label-position="top">
          <el-form-item
            :label="$t('data.receiver_type') "
            prop="receiver_type"
            required
          >
            <el-select v-model="form.receiver_type" filterable class="select-item" clearable :disabled="isEdit">
              <el-option
                v-for="(item,index) in receiverTypeMap"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>

          <el-form-item
            :label="$t('data.receiver_account')"
            prop="receiver_account"
            required
          >
            <el-input v-model="form.receiver_account" clearable type="text" maxlength="30" class="input-item" :placeholder="$t('tips.please_enter')" autocomplete="off"  :disabled="isEdit"/>
          </el-form-item>

          <el-form-item
            :label="$t('data.receiver_name')"
            prop="receiver_name"
          >
            <el-input v-model="form.receiver_name" clearable type="text" maxlength="100" class="input-item" :placeholder="$t('tips.please_enter')" autocomplete="off"  :disabled="isEdit"/>
          </el-form-item>

          <el-form-item
            :label="$t('data.nick_name')"
            prop="remark_name"
          >
            <el-input v-model="form.remark_name" clearable type="text" maxlength="30" class="input-item" :placeholder="$t('tips.please_enter')" autocomplete="off"/>
          </el-form-item>

          <el-form-item
            :label=" $t('data.receiver_relation') "
            prop="relation_type"
            required
          >
            <el-select v-model="form.relation_type" filterable class="select-item" clearable>
              <el-option
                v-for="(item,index) in receiverRelationMap"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>

          <!-- 当与接收方关系选择“自定义”时，显示该字段 -->
          <el-form-item
            v-if="form.relation_type === 11"
            :label="$t('data.customize')"
            prop="custom_relation"
            required
          >
            <el-input v-model="form.custom_relation" clearable type="text" maxlength="30" class="input-item" :placeholder="$t('tips.please_enter')" autocomplete="off"/>
          </el-form-item>

          <el-form-item
            :label=" $t('data.relation_document') "
            prop="relation_document"
          >
            <div>
              <div v-if="form.relation_proof_relative_url" style="margin-bottom: 10px">
                <div class="content-file">
                  <el-image
                    v-if="isImg(form.relation_proof_relative_url)"
                    style="height:150px"
                    :src="form.relation_proof_absolute_url"
                    :preview-src-list="[form.relation_proof_absolute_url]"
                  />
                  <span v-else @click="onClickFile">{{ form.relation_proof_relative_url }}</span>
                </div>

                <el-button type="danger" size="mini" style="margin-left: 10px" icon="el-icon-delete" @click="onClickRemoveBtn()">{{ $t('components.delete') }}</el-button>
              </div>
              <UploadFile
                v-else
                @templateFileSuccess="templateFileSuccess"
                v-on="$listeners"
                accept-type=".jpg,.jpeg,.png,.pdf"
                :limit-size="5"
                file-dir="SPLIT_PAYMENT_RECEIVER_FILE"
              />
              <div style="color: #a1a1a1;">{{ $t('tips.split_receiver_upload_tips') }}</div>
            </div>
          </el-form-item>
        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ $t('components.cancel') }}</el-button>
        <el-button type="info" :disabled="submiting" class="btn-submit" @click="onClickSubmitBtn">{{ $t('components.submit') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { PostSplitPaymentReceiverAdd, PostSplitPaymentReceiverUpdate } from '@/api/data/data.js'
import { receiverRelationMap, receiverTypeMap } from '@/utils/maps'

export default {
  components: {
    UploadFile: () => import('@/views/components/Upload/UploadFile.vue')
  },
  data() {
    const validAttachmentName = (rule, value, callback) => {
      if (!this.form.attachment_name) {
        return callback(new Error('Please upload file'))
      }
      callback()
    }

    const checkNumberType = (rule, value, callback) => {
      if (/\s/g.test(value)) {
        return callback(new Error('The input value cannot contain spaces'))
      }
      // if (value !== '0' && !Number(value)) {
      //   return callback(new Error('Only can input number'))
      // }
      return callback()
    }

    const checkReceiverAccount = (rule, value, callback) => {
      if (!value) {
        return callback()
      }
      const re = /^[A-Za-z0-9]+$/
      if (!re.test(value)) {
        return callback(new Error('Only letters and numbers are allowed'))
      }
      return callback()
    }

    return {
      form: {},
      dialogVisible: false, // 控制弹框显示隐藏
      submiting: false,
      isEdit: false,
      rule: {
        receiver_account: [
          { validator: checkReceiverAccount, trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    receiverRelationMap() {
      return receiverRelationMap()
    },
    receiverTypeMap() {
      return receiverTypeMap().filter(item => item.value === 1)
    },
  },
  created() {},
  methods: {
    isImg(value) {
      return /\.(gif|jpg|jpeg|png|GIF|JPG|PNG)$/.test(value)
    },
    onClickRemoveBtn() {
      this.form.relation_proof_absolute_url = undefined
      this.form.relation_proof_relative_url = undefined
      this.$forceUpdate()
    },
    templateFileSuccess(data = {}) {
      this.form.relation_proof_relative_url = data.relativePath
      this.form.relation_proof_absolute_url = data.absolutePath
      this.$forceUpdate()
    },
    // 改变弹框状态
    showModal(form = {}) {
      this.dialogVisible = true
      this.form = form
      if (form.bind_no) {
        this.isEdit = true
        this.form.relation_proof_relative_url = form.relation_proof_url
        this.form.relation_proof_absolute_url = form.relation_proof_full_url
      } else {
        this.isEdit = false
      }
      this.$nextTick(() => this.$refs.form.clearValidate())
    },
    onClickSubmitBtn() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submiting = true
          const { relation_proof_absolute_url, relation_proof_relative_url, ...others } = this.form
          const params = {
            ...others,
            relation_proof_url: relation_proof_relative_url || ''
          }
          const requestFn = this.isEdit ? PostSplitPaymentReceiverUpdate : PostSplitPaymentReceiverAdd
          requestFn(params).then(res => {
            this.$message.success('Success')
            this.dialogVisible = false
            this.$emit('submit')
          }).finally(() => {
            this.submiting = false
          })
        }
      })
    },
    onClickFile() {
      window.open(this.form.relation_proof_absolute_url, '_blank')
    }
  }
}
</script>

<style scoped>
.singleDisbursementModal /deep/ .el-input--suffix .el-input__inner {
  padding-right: 60px;
}
.singleDisbursementModal /deep/ .el-dialog__header {
  padding: 12px 24px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.20);
}
.icon-question{
  position: relative;
  top: -1px;
  margin-left: 5px;
  font-size: 12px;
}
.select-item{
  width: 100%;
}
.tip{
  font-size: 14px;
  font-weight: 400;
  color: #303133;
}
.dialog-footer{
  margin-top: -16px;
  /* text-align: center; */
}
.btn-submit{
  /* width: 500px;
  height: 40px;
  border-radius: 4px; */
}
.content-file{
  display: inline-block;
  width: 330px;
  vertical-align: middle;
  color:#3855F1;
  text-decoration: underline;
  cursor: pointer;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
}

</style>
